module.exports = __webpack_public_path__ + "static/img/home_1.a42129a5.png";